import IProduct from '../../../functions/src/models/Product';

/** Returns the minimum and maximum price over all products. */
export function getPriceRange(
  products: IProduct[]
): { min: number; max: number } {
  const prices = products.map(product => product.price);
  return { min: Math.min(...prices), max: Math.max(...prices) };
}
